export default function AboutMe() {
    return(
        <section id="AboutMe" className="about--section">
            <div className="about--section-img">
                <img src="./img/about-me.png" alt="About Me" />
            </div>
            <div className="hero--section--content--box about--section--box">
                <div className="hero--section--content">
                    <p className="section--title">About</p>
                    <h1 className="skills-section--heading">About Me</h1>
                    <p className="hero--section--description">Hello there! 👋 I'm Abdelhadi, a passionate web developer based in Algeria. With a background in both front end and back end technologies, I specialize in creating dynamic and interactive websites that not only look great but also deliver a seamless user experience.</p>
                    
                    <p className="hero--section--description">I believe in the importance of clean and maintainable code. Whether I'm designing a user interface or architecting a database, my focus is on creating solutions that stand the test of time. I'm always eager to stay updated with the latest industry trends and technologies to ensure that my work is at the forefront of innovation.</p>
                    
                </div>
            </div>
        </section>
    )
}
